import { Link } from "react-router-dom";
import { Instagram, Facebook, Youtube, MapPin, Phone, Mail } from "lucide-react";
import { LOGOS, CONTACT } from "@/data/site";

const iconMap = { instagram: Instagram, facebook: Facebook, youtube: Youtube };

const footerLinks = [
  { to: "/experience", label: "Experience" },
  { to: "/pricing", label: "Pricing & Packages" },
  { to: "/group-events", label: "Group Events" },
  { to: "/edukarting", label: "EduKarting" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-[#050505]">
      <div className="checker-texture absolute inset-x-0 top-0 h-1.5 opacity-40" />
      <div className="mx-auto grid max-w-[1400px] gap-12 px-5 py-16 md:grid-cols-12 md:px-10 md:py-24">
        <div className="md:col-span-5">
          <div className="inline-flex h-24 w-24 items-center justify-center rounded-2xl bg-white p-2">
            <img src={LOGOS.icon} alt="Karting Bahamas" className="h-full w-full object-contain" />
          </div>
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/55">
            A hand-built outdoor go-kart track on the 150,000+ sq ft Southern Parking Lot of the
            Thomas A. Robinson National Stadium, Nassau. A Bahamas Motor Sports Federation venue.
          </p>
          <div className="mt-6 flex flex-col gap-3">
            {CONTACT.socials.map((s) => {
              const Icon = iconMap[s.icon];
              return (
                <a
                  key={s.name}
                  href={s.href}
                  target="_blank"
                  rel="noreferrer"
                  data-testid={`footer-social-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="group inline-flex w-fit items-center gap-3 rounded-xl border border-white/15 bg-white/5 px-4 py-2.5 text-sm text-white/70 transition-colors hover:border-kbcyan hover:text-kbcyan"
                >
                  <Icon className="h-5 w-5" />
                  <span>{s.name}</span>
                </a>
              );
            })}
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display text-2xl tracking-wide text-white">Explore</h4>
          <ul className="mt-5 space-y-3">
            {footerLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
                  className="text-sm text-white/60 transition-colors hover:text-kbyellow"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-display text-2xl tracking-wide text-white">Visit The Track</h4>
          <ul className="mt-5 space-y-4 text-sm text-white/60">
            <li className="flex gap-3">
              <MapPin className="mt-0.5 h-5 w-5 flex-shrink-0 text-kbcyan" />
              <span>{CONTACT.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone className="mt-0.5 h-5 w-5 flex-shrink-0 text-kbcyan" />
              <a href={`tel:${CONTACT.phone}`} className="hover:text-white">{CONTACT.phone}</a>
            </li>
            <li className="flex gap-3">
              <Mail className="mt-0.5 h-5 w-5 flex-shrink-0 text-kbcyan" />
              <a href={`mailto:${CONTACT.email}`} className="hover:text-white">{CONTACT.email}</a>
            </li>
          </ul>
          <div className="mt-6 flex items-center gap-4">
            <img src={LOGOS.bac} alt="Bahamas Automobile Club" className="h-9 w-auto opacity-80" />
            <img src={LOGOS.edukarting} alt="EduKarting Bahamas" className="h-14 w-auto" />
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-[1400px] flex-col items-center justify-between gap-3 px-5 py-6 text-xs text-white/40 md:flex-row md:px-10">
          <p>© {new Date().getFullYear()} Karting Bahamas. All rights reserved.</p>
          <p className="tracking-wide">NASSAU · THE BAHAMAS · EST. 2024</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
